function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_925",
  "data-name": "Group 925",
  transform: "translate(-103.385 -217.203)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_922",
  "data-name": "Group 922",
  transform: "translate(114.405 221.194)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_169",
  "data-name": "Path 169",
  d: "M7.213,0a3.816,3.816,0,0,1,3.809,3.854A3.888,3.888,0,0,1,9.275,7.081a7.265,7.265,0,0,1,5.2,6.184c.09.807-1.255.851-1.344.134a5.978,5.978,0,0,0-11.876,0c-.09.717-1.434.672-1.344-.134A7.376,7.376,0,0,1,5.152,7.081,3.835,3.835,0,0,1,7.213,0Zm0,1.344a2.487,2.487,0,1,0,2.465,2.51A2.505,2.505,0,0,0,7.213,1.344Z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_923",
  "data-name": "Group 923",
  transform: "translate(103.881 217.603)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_169-2",
  "data-name": "Path 169",
  d: "M5.733,0A3.043,3.043,0,0,1,8.77,3.073,3.1,3.1,0,0,1,7.377,5.646a5.793,5.793,0,0,1,4.145,4.932c.071.643-1,.679-1.072.107a4.767,4.767,0,0,0-9.47,0c-.071.572-1.144.536-1.072-.107A5.882,5.882,0,0,1,4.089,5.646,3.058,3.058,0,0,1,5.733,0Zm0,1.072a1.983,1.983,0,1,0,1.965,2A2,2,0,0,0,5.733,1.072Z",
  transform: "translate(0)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.8
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_924",
  "data-name": "Group 924",
  transform: "translate(127.881 217.603)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_169-3",
  "data-name": "Path 169",
  d: "M5.733,0A3.043,3.043,0,0,1,8.77,3.073,3.1,3.1,0,0,1,7.377,5.646a5.793,5.793,0,0,1,4.145,4.932c.071.643-1,.679-1.072.107a4.767,4.767,0,0,0-9.47,0c-.071.572-1.144.536-1.072-.107A5.882,5.882,0,0,1,4.089,5.646,3.058,3.058,0,0,1,5.733,0Zm0,1.072a1.983,1.983,0,1,0,1.965,2A2,2,0,0,0,5.733,1.072Z",
  transform: "translate(0)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.8
})));

var SvgInvitationsPostsIcon = function SvgInvitationsPostsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.422,
    height: 18.149,
    viewBox: "0 0 36.422 18.149",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvitationsPostsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invitations-posts-icon.f8990bcc.svg";
export { ForwardRef as ReactComponent };